var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPmVisa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 46,
    viewBox: "0 0 66 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 45,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 45,
    rx: 5.5,
    stroke: "#E9EAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3885 30.3954H16.4821L13.5527 18.7691C13.4137 18.2343 13.1185 17.7615 12.6842 17.5387C11.6005 16.9787 10.4063 16.533 9.10352 16.3082V15.8606H15.3964C16.2649 15.8606 16.9163 16.533 17.0249 17.3139L18.5448 25.7003L22.4493 15.8606H26.2471L20.3885 30.3954ZM28.4184 30.3954H24.7291L27.767 15.8606H31.4563L28.4184 30.3954ZM36.2293 19.8872C36.3379 19.1043 36.9893 18.6567 37.7492 18.6567C38.9434 18.5443 40.2443 18.7691 41.3299 19.3272L41.9813 16.1978C40.8957 15.7502 39.7015 15.5254 38.6177 15.5254C35.037 15.5254 32.4315 17.5387 32.4315 20.3328C32.4315 22.4585 34.2771 23.5746 35.5798 24.247C36.9893 24.9175 37.5321 25.3651 37.4235 26.0355C37.4235 27.0412 36.3379 27.4888 35.2542 27.4888C33.9514 27.4888 32.6486 27.1536 31.4563 26.5936L30.8049 29.7249C32.1077 30.283 33.5171 30.5078 34.8199 30.5078C38.8349 30.6182 41.3299 28.6069 41.3299 25.5879C41.3299 21.7861 36.2293 21.5633 36.2293 19.8872ZM54.2415 30.3954L51.3121 15.8606H48.1657C47.5143 15.8606 46.8629 16.3082 46.6458 16.9787L41.2214 30.3954H45.0192L45.7773 28.2716H50.4436L50.8779 30.3954H54.2415ZM48.7085 19.7748L49.7922 25.2527H46.7543L48.7085 19.7748Z",
    fill: "#172B85"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPmVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_PM_visa.4913e9f44c34322d8a2a65575ffd7612.svg";